$(function () {
  const $emailRadio = $('input[name="emailChois"]:radio');
  const $emailRadioChecked = $('input[name="emailChois"]:radio:checked');
  const $emailInput = $('#emailInput');
  const inputToggle = function(value) {
    if (value === 'OTHER_EMAIL') {
      $emailInput.parent().slideDown();
    } else {
      $emailInput.parent().slideUp();
      $emailInput.val('');
    }
  };
  if ($emailRadio.length) {
    inputToggle($emailRadioChecked.val());
    $emailRadio.change(function (e) {
      inputToggle(e.target.value);
    });
  }
});
